import React, { useEffect, useMemo, useState } from 'react';
import { convertToINR, strToNum } from '../EstateManagement.controller';
import { set } from 'lodash';
import { endpoints, POST, requestInfo } from '../../../../services/modulesServices/userManagement.api';
import { TENANT_ID } from '../../../../utils/constants';

export const TDSSection = ({ deductions, setDeductions, totalAmount, finalPayableAmount, setFinalPayableAmount, transactionDetails }: any) => {
    const userId = JSON.parse(localStorage.getItem('user') || '{}')?.uuid;

    // const [finalAmount, setFinalAmount] = useState(0);

    useEffect(() => {
        // setFinalAmount(totalAmount);
        setFinalPayableAmount(strToNum(totalAmount)?.toFixed(2));

        (async () => {
            try {
                const { data } = await POST(endpoints.searchExistingUser + `?tenantId=${TENANT_ID}&userUuid=${userId}`, { RequestInfo: requestInfo() });
                if (data.enterpriseEntity?.[0].category === 'GOV_STAT_CORP') {
                    setTimeout(() => {
                        setDeductions((prev: any) => ({ ...prev, GST_TDSEnabled: true }));
                    }, 1000);
                }
            } catch (e) {
                console.log(e);
            }
        })();
    }, [totalAmount]);

    const handleCheck = (e: any) => {
        console.log(finalPayableAmount, 'finalPayableAmount');
        let payableAmount = strToNum(finalPayableAmount);
        if (e.target.checked && e.target.name === 'TDS') {
            payableAmount = payableAmount - deductions?.TDSAmount - (deductions.defaultInterestTDSAmount || 0) - (deductions.TDSLPInterestAmount || 0) - (deductions.subleaseTDSAmount || 0);
            setDeductions({ ...deductions, TDSChecked: true });
        } else if (e.target.checked && e.target.name === 'GST_TDS') {
            payableAmount =
                payableAmount - deductions?.GST_TDSAmount - (deductions.defaultInterestGST_TDSAmount || 0) - (deductions.GST_TDSLPInterestAmount || 0) - (deductions.subleaseGST_TDSAmount || 0);
            setDeductions({ ...deductions, GST_TDSChecked: true });
        } else if (!e.target.checked && e.target.name === 'TDS') {
            payableAmount = payableAmount + deductions?.TDSAmount + (deductions.defaultInterestTDSAmount || 0) + (deductions.TDSLPInterestAmount || 0) + (deductions.subleaseTDSAmount || 0);
            setDeductions({ ...deductions, TDSChecked: false });
        } else if (!e.target.checked && e.target.name === 'GST_TDS') {
            payableAmount =
                payableAmount + deductions?.GST_TDSAmount + (deductions.defaultInterestGST_TDSAmount || 0) + (deductions.GST_TDSLPInterestAmount || 0) + (deductions.subleaseGST_TDSAmount || 0);
            setDeductions({ ...deductions, GST_TDSChecked: false });
        }

        // setFinalAmount(payableAmount);
        setFinalPayableAmount(+payableAmount.toFixed(2));
    };

    const tdsDeductions = useMemo(() => {
        return transactionDetails?.additionalDetails?.paymentReceiptDetails?.feeDetails?.find((fee: any) => fee.feeDescription === 'TDS Deduction')?.feeAmount || 0;
    }, [transactionDetails]);

    const gstTdsDeductions = useMemo(() => {
        return transactionDetails?.additionalDetails?.paymentReceiptDetails?.feeDetails?.find((fee: any) => fee.feeDescription === 'GST-TDS Deduction')?.feeAmount || 0;
    }, [transactionDetails]);

    console.log('transactionDetails', transactionDetails, deductions);
    return (
        <div className={`col-sm-12 ps-3 d-flex justify-content-end pt-3 `} style={{ borderTop: `1px solid #33333314`, paddingRight: '31px', textAlign: 'end' }}>
            <div className='d-flex flex-column'>
                {!transactionDetails?.txnId ? (
                    <>
                        <div className='mb-3 d-flex gap-1 justify-content-between'>
                            <span>{'Total Amount (in INR) :'}</span>
                            <span>{convertToINR(transactionDetails?.txnId ? transactionDetails?.additionalDetails?.paymentReceiptDetails.totalPaidAmount : totalAmount)}</span>
                        </div>
                        <label className={`mb-3 d-flex gap-1 justify-content-between ${deductions.TDSDisabled ? 'd-none' : ''}`} htmlFor={'TDS'}>
                            <div>
                                <input
                                    type='checkbox'
                                    name='TDS'
                                    onChange={handleCheck}
                                    id='TDS'
                                    checked={deductions.TDSChecked}
                                    disabled={deductions.TDSDisabled}
                                    className={deductions.TDSDisabled ? 'default-checked' : ''}
                                />
                                {/* <span>{'TDS Deduction (10%)'} :</span> */}
                                <span>{'TDS Deduction'} :</span>
                            </div>
                            <span>
                                {deductions.TDSChecked
                                    ? `- ${convertToINR(deductions?.TDSAmount + (deductions.defaultInterestTDSAmount || 0) + (deductions.TDSLPInterestAmount || 0) + (deductions.subleaseTDSAmount || 0))} `
                                    : `--`}
                            </span>
                        </label>
                        <label className={`mb-3 d-flex gap-1 justify-content-between ${deductions.GST_TDSEnabled ? '' : 'd-none'}`} htmlFor={'GST_TDS'}>
                            <div>
                                <input
                                    type='checkbox'
                                    name='GST_TDS'
                                    onChange={handleCheck}
                                    id='GST_TDS'
                                    checked={deductions.GST_TDSChecked}
                                    disabled={!deductions.GST_TDSEnabled}
                                    className={deductions.GST_TDSEnabled ? '' : 'default-checked'}
                                />
                                {/* <span>{'GST TDS Deduction (2%)'} :</span> */}
                                <span>{'GST TDS Deduction'} :</span>
                            </div>
                            <span>
                                {deductions.GST_TDSChecked
                                    ? `- ${convertToINR(deductions?.GST_TDSAmount + (deductions.defaultInterestGST_TDSAmount || 0) + (deductions.GST_TDSLPInterestAmount || 0) + (deductions.subleaseGST_TDSAmount || 0))}`
                                    : `--`}
                            </span>
                        </label>
                        <div className='mb-3 d-flex gap-1 justify-content-between'>
                            <span>{'Total Payable Amount (in INR) : '}</span>
                            <span className='ms-3'>{convertToINR(finalPayableAmount)}</span>
                        </div>
                    </>
                ) : (
                    <>
                        {tdsDeductions ? (
                            <div className='mb-3 d-flex gap-1 justify-content-between'>
                                <span>{'TDS Deduction :'}</span>
                                <span>{convertToINR(tdsDeductions)}</span>
                            </div>
                        ) : (
                            <></>
                        )}
                        {gstTdsDeductions ? (
                            <div className='mb-3 d-flex gap-1 justify-content-between'>
                                <span>{'GST TDS Deduction :'}</span>
                                <span>{convertToINR(gstTdsDeductions)}</span>
                            </div>
                        ) : (
                            <></>
                        )}

                        <div className='mb-3 d-flex gap-1 justify-content-between'>
                            <span>{'Total Paid Amount (in INR) :'}</span>
                            <span>{convertToINR(transactionDetails?.txnId ? transactionDetails?.additionalDetails?.paymentReceiptDetails.totalPaidAmount : totalAmount)}</span>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

TDSSection.defaultProps = {
    deductions: {},
    setDeductions: () => {},
    totalAmount: 0,
    finalPayableAmount: 0,
    setFinalPayableAmount: () => {},
    transactionDetails: {}
};
